<template>
    <app-button
        :icon="getIcon(icon, iconStyle)"
        :icon-color="iconColor"
        :icon-size="iconSize"
        :tooltip="tooltipText"
        :loading="loading"
        :disabled="disabled"
        x-small
        @click="copyText"
    />
</template>

<script>
export default {
    name: 'AppCopyButton',
    props: {
        value: {
            type: [String, Number],
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        iconSize: {
            type: String,
            default: '1em'
        },
        iconColorBefore: {
            type: String,
            default: 'primaryText'
        },
        tooltip: {
            type: String,
            default: null
        }
    },
    data: () => ({
        icon: 'copy',
        iconStyle: 'fad',
        iconColor: 'primaryText',
        loading: false
    }),
    computed: {
        tooltipText() {
            if (this.disabled) {
                return null;
            }

            if (this.loading) {
                return null;
            }

            if (this.tooltip) {
                return this.tooltip;
            }

            return this.$t('copy');
        }
    },
    watch: {
        iconColorBefore: {
            immediate: true,
            handler(newColor) {
                this.iconColor = newColor;
            }
        }
    },
    methods: {
        async copyText() {
            this.copyToClipboard(this.value);

            this.icon = 'success';
            this.iconStyle = 'fad';
            this.iconColor = 'success';

            await this.wait(2000);

            this.icon = 'copy';
            this.iconStyle = 'fad';
            this.iconColor = this.iconColorBefore;
        }
    }
};
</script>
